<dss-libs-feature-sidebar
  (sidebarCollapseEvent)="sidebarCollapseEvent()"
  (sidebarCollapsePhoneEvent)="sidebarCollapsePhoneEvent()"
></dss-libs-feature-sidebar>

<main
  dssLibsUiAutoHideScrollbar
  [class]="layoutService.extendLayout() ? 'lg:ms-62' : 'lg:ms-24'"
  class="relative duration-200 px-4 py-8 lg:py-9 lg:px-13.5 lg:ease-in-out lg:transition-width h-screen"
>
  <router-outlet></router-outlet>
</main>
<dss-libs-feature-payment-plans></dss-libs-feature-payment-plans>
